export default __webpack_public_path__ + "static/media/close.1f71e895.svg";